module.exports = __webpack_public_path__ + "static/img/png.e2386478.png";